import React from 'react';
import { SHARED_STYLES, VIEWPORTS } from '@constants';
import { useViewport } from '@hooks/useViewport';
import { SecondarySidebarButton } from './Sidebar/styles';

export const ToggleViewport = ({ viewportData, slideRef, dispatch }) => {
    const { maxSlideWidth } = SHARED_STYLES;
    const { desktop } = VIEWPORTS;
    const { clientConnected, viewport, slideWidth } = viewportData;

    function changeViewport() {
        if (viewport !== desktop) {
            useViewport(parseInt(maxSlideWidth), dispatch);
         
            slideRef.current.style.width = maxSlideWidth;
        } else {
            useViewport(slideWidth, dispatch);
            slideRef.current.style.width = `${slideWidth}px`;
        }
    }

    return (
        <SecondarySidebarButton
            onClick={changeViewport} 
            margin='10px'
            disabled={clientConnected}>
                Toggle Viewport
        </SecondarySidebarButton>
    );
};

export default ToggleViewport;
